const MOBILE_PHONE_NUMBER_MAX_DIGITS = 11;

export function formatMobilePhoneNumber(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, MOBILE_PHONE_NUMBER_MAX_DIGITS);

  if (digits.length <= 3) {
    return digits;
  }

  if (digits.length <= 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  if (digits.length <= 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export function formatPhoneNumberForDisplay(value?: string, fallback = '-') {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return fallback;
  }

  if (trimmedValue.includes('*')) {
    return trimmedValue;
  }

  return formatMobilePhoneNumber(trimmedValue) || fallback;
}

export function isValidMobilePhoneNumber(value: string) {
  if (!value) {
    return true;
  }

  const segments = value.split('-');
  if (segments.length !== 3) {
    return false;
  }

  const [prefix, middle, suffix] = segments;
  return (
    prefix.length === 3
    && (middle.length === 3 || middle.length === 4)
    && suffix.length === 4
    && segments.every((segment) => segment
      .split('')
      .every((character) => character >= '0' && character <= '9'))
  );
}
